// Nout used yet in any component
import React from "react";
import styled from "styled-components";
import { CheckIcon } from "./Icons";

const CustomCheckbox = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 4px; /* Rounded corners */
  border: 2px solid ${(props) => (props.checked ? "#2399A1" : "#6c757d")};
  margin-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${(props) => (props.checked ? "#2399A1" : "transparent")};
  transition: background-color 0.2s, border-color 0.2s;

  .icon {
    width: 24px;
    height: 24px;
    transform: ${(props) => (props.checked ? "scale(1)" : "scale(0)")};
    transition: transform 0.3s ease;
  }
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: ${(props) => (props.checked ? "bold" : "normal")};
`;

const CheckboxInput = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const Checkbox = ({ label, name, checked, onChange }) => {
  return (
    <CheckboxLabel checked={checked}>
      <CheckboxInput name={name} checked={checked} onChange={onChange} />
      <CustomCheckbox checked={checked}>
        <span className="icon">{checked && <CheckIcon color="#FFF" />}</span>
      </CustomCheckbox>
      {label}
    </CheckboxLabel>
  );
};

export default Checkbox;
